import React, { useState } from "react";
import { fetchPendingExpenseCount } from "../utilities/expenses";

import smallLogo from "../assets/images/logo-small.png";
import classes from "./index.module.css";

import nonotification from "../assets/images/noNotification.png";
import {
  Typography,
  Avatar,
  Menu,
  MenuItem,
  Button,
  ClickAwayListener,
  Modal,
  Badge,
  Box,
} from "@mui/material";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { authApi, getAuthorizationHeader } from "../api-calls/user-requests";
import {
  GET_NOTIFICATIONS,
  GET_USER,

  UPDATE_NOTIFICATION,
} from "../api-calls/api-urls";
import {
  ToggleSideBar,
  setCurrentUser,
  setHeaderName,
  setNotificationList,
} from "../Redux/actions/user-actions";
import { getLanguagedataFunction } from "../utilities/language";
import LanguageModal from "./LanguageModal";
import {
  AboutusIcon,
  CallIcon,
  FeedBackIcon,
  LanguageChangeIcon,
  LogoutIcon,
  MenuBar,
  MyProfileIcon,
  NotificationBellIcon,
  PolicyIcon,
  ResetpasswordIcon,
} from "./Icons";

import { getNotificationUnseenCount, stringAvatar, disconnectMqtt } from "../utilities/commonFunctions";
import NotificationItem from "./notificationItem";
import Cookies from "js-cookie";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#f5f5f9",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #dadde9",
  },
}));

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(false);
  const rootRef = React.useRef(null);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  const user = useSelector((state) => state.allUsers.logedUser);
  const [logoutModal, setLogoutModal] = useState(false);
  const [moddleToggle, setModdleToggle] = useState(false);
  const { headerName, notificationList, mqttStatus } = useSelector(
    (state) => state.allUsers
  );


  // const [currentUser, setCurrentUser] = useState();
  const currentUser = useSelector(
    (state) => state.allUsers.current_user
  );
  const open = Boolean(anchorEl);
  const ln = useSelector((state) => state.allUsers.language_json);
  const togglesidebar = useSelector(
    (state) => state.allUsers.togglesidebar
  );
  const [menuopen, setMenuOpen] = React.useState(false);


  const handleClickOpen = () => {
    setMenuOpen(!menuopen);
  };

  React.useEffect(() => {
    if (!ln) {
      getLanguagedataFunction(dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const closeModal = () => {
    setModdleToggle(false);
    setLogoutModal(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const mqttStatusColors = {
    connected: "#4caf50",
    connecting: "#ff9800",
    disconnected: "#9e9e9e",
    error: "#f44336",
  };

  const mqttStatusLabels = {
    connected: "Live data connected",
    connecting: "Connecting to live data...",
    disconnected: "Live data disconnected",
    error: "Live data connection error",
  };

  const handleLogout = () => {
    disconnectMqtt(dispatch);
    Cookies.remove("userToken");
    sessionStorage.removeItem("userInfo");
    localStorage.clear();
    handleClose();
    navigate("/login");
  };

  const handleChangeLanguage = () => {
    handleClose();
    setModdleToggle(true);
  };
  const handleMyProfileClick = () => {
    handleClose();
    navigate("/my-profile");
  };
  const handleResetPassword = () => {
    handleClose();
    dispatch(setHeaderName("Reset Password"));
    navigate("/reset-password");
  };

  const handleCloseNotification = () => {
    setMenuOpen(false);
  };

  const handleMarkAsRead = (id) => {
    try {
      const { data } = authApi.put(
        `${UPDATE_NOTIFICATION}/${id}`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      getNotifications();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const path = window.location.pathname;
    const Arr = path.split("/");
    const name = Arr[1].replaceAll("-", "_").toString();
    //get lable from json
    if (ln) {
      const lable = ln[name];
      dispatch(setHeaderName(lable));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ln]);

  const getCurrentLoggedUser = async (id) => {
    try {
      const { data } = await authApi.get(`${GET_USER}/${id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      if (data.message === "User not found") {
        handleLogout();
      } else {
        dispatch(setCurrentUser(data));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleContactUS = () => {
    handleClose();
    navigate("/contact-us");
  };

  const handleAboutUsClick = () => {
    handleClose();
    navigate("/about-us");
    dispatch(setHeaderName("About Us"));
  };

  const handlePoliciesClick = () => {
    handleClose();
    navigate("/policies");
    dispatch(setHeaderName("Policies"));
  };

  const handleFeedback = () => {
    handleClose();
    navigate("/feedback");
  };

  const handleSideBarToggle = () => {
    dispatch(ToggleSideBar(!togglesidebar));
  };

  const handleViewAllNotification = () => {
    dispatch(setHeaderName("Notifications"));
    setMenuOpen(false);
    navigate("/notifications");
  };

  useEffect(() => {
    const token = Cookies.get("userToken");
    if (userInfo && userInfo?._id) {
      getCurrentLoggedUser(userInfo?._id);
    } else if (token) {
      const userData = JSON.parse(token);
      getCurrentLoggedUser(userData?._id);
    } else {
      getCurrentLoggedUser(user?._id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo?._id, user?._id]);

  useEffect(() => {
    getNotifications();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getNotifications = async () => {
    try {
      const { data } = await authApi.get(
        `${GET_NOTIFICATIONS}/${userInfo?._id}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log("Notification List ====>", data);
      dispatch(setNotificationList(data));
      // A new "expense awaiting approval" arrives as a notification too.
      fetchPendingExpenseCount(dispatch);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAllMarkAsRead = () => {
    try {
      const { data } = authApi.put(
        `${UPDATE_NOTIFICATION}/all`,
        {},
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      getNotifications();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      {ln ? (
        <div className={`${classes.header_flex} ${classes.header_maindiv}`}>
          <div className={`${classes.header_flex} ${classes.second_maindiv}`}>
            <div>
              <span className="logo-lg" style={{ marginBottom: '48px' }}>
                {togglesidebar ? (
                  <div className={classes.HeaderLogo_div}>
                    <img
                      src={smallLogo}
                      alt=""
                      className={classes.HeaderLogoImage}
                    />
                    <p>Team Player</p>
                  </div>
                ) : (
                  <img
                    src={smallLogo}
                    alt=""
                    className={classes.HeaderSmallLogoImage}
                    width={"32px"}
                  />
                )}
              </span>
            </div>
            <div
              className={`${classes.header_flex} ${classes.header_MenuIcon}`}
            >
              <span onClick={() => handleSideBarToggle()}>
                <MenuBar />
              </span>
              <Typography>{headerName}</Typography>
            </div>
          </div>
          {currentUser ? (
            <div
              className={`${classes.header_flex} ${classes.second_maindiv}`}
              style={{
                columnGap: "20px",
              }}
            >
              <Tooltip title={mqttStatusLabels[mqttStatus] || mqttStatusLabels.disconnected}>
                <span style={{ display: "flex", alignItems: "center", columnGap: "5px", cursor: "default" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      backgroundColor: mqttStatusColors[mqttStatus] || mqttStatusColors.disconnected,
                      boxShadow: mqttStatus === "connected" ? `0 0 6px ${mqttStatusColors.connected}` : "none",
                      flexShrink: 0,
                    }}
                  />
                  <Typography style={{ fontSize: 12, color: mqttStatusColors[mqttStatus] || mqttStatusColors.disconnected }}>
                    {mqttStatus === "connected" ? "Live" : mqttStatus === "connecting" ? "Connecting" : mqttStatus === "error" ? "Error" : "Offline"}
                  </Typography>
                </span>
              </Tooltip>
              <div style={{ position: "relative" }}>
                <ClickAwayListener onClickAway={handleCloseNotification}>
                  <div>
                    <HtmlTooltip
                      PopperProps={{
                        disablePortal: true,
                      }}
                      className={classes.TooltipClasses}
                      open={menuopen}
                      disableFocusListener
                      disableHoverListener
                      disableTouchListener
                      title={
                        <React.Fragment>
                          <div className={classes.tooltip_arrow} />
                          <div className={classes.menuItem}>
                            <Typography className={classes.TooltipHEader}>
                              Notification
                              <span className={classes.unseencount}>
                                {getNotificationUnseenCount(notificationList)}
                              </span>
                            </Typography>
                            <Button
                              variant="text"
                              className={`${classes.TooltipmarkText}`}
                              onClick={() => handleAllMarkAsRead()}
                            >
                              Mark all as read
                            </Button>
                          </div>
                          {notificationList && notificationList?.length > 0 ? (
                            <div>
                              <div
                                className={classes.notificationListContainer}
                              >
                                {notificationList.map((item, index) => (
                                  <NotificationItem
                                    item={item}
                                    key={index}
                                    handleMarkAsRead={handleMarkAsRead}
                                    onOpen={() => setMenuOpen(false)}
                                  />
                                ))}
                              </div>
                              <div className={classes.viewAllbtnSection}>
                                <Button
                                  variant="text"
                                  className={`${classes.TooltipmarkText}`}
                                  onClick={() => handleViewAllNotification()}
                                >
                                  {ln.view_all}
                                </Button>
                              </div>
                            </div>
                          ) : (
                            <div className={classes.NoImaheContainer}>
                              <img src={nonotification} alt="" />
                            </div>
                          )}
                        </React.Fragment>
                      }
                    >
                      <Badge
                        badgeContent={getNotificationUnseenCount(
                          notificationList
                        )}
                        color="secondary"
                        variant="outlined"
                        onClick={handleClickOpen}
                        sx={{ Padding: 0, border: "none", minWidth: 0 }}
                        className={classes.HeaderNotificationButton}
                      >
                        <NotificationBellIcon />
                      </Badge>
                    </HtmlTooltip>
                  </div>
                </ClickAwayListener>
                {/* <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit">Tooltip with HTML</Typography>
                    <em>{"And here's"}</em> <b>{"some"}</b>{" "}
                    <u>{"amazing content"}</u>. {"It's very engaging. Right?"}
                  </React.Fragment>
                }
              ></HtmlTooltip> */}
              </div>
              <div
                className={`${classes.header_flex} ${classes.AvatarDiv}`}
                aria-controls={open ? "basic-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleClick}
              >
                {userInfo &&
                userInfo.profile_pic &&
                userInfo.profile_pic?.destination ? (
                  <Avatar
                    alt="Remy Sharp"
                    src={`${process.env.REACT_APP_IMAGE_URL}/${userInfo?.profile_pic?.destination}${userInfo?.profile_pic?.filename}`}
                  />
                ) : (
                  <Avatar
                    {...stringAvatar(
                      `${currentUser.first_name?.trim()} ${
                        currentUser.last_name?.trim().charAt(0).toUpperCase() +
                        currentUser.last_name?.trim().slice(1)
                      }`
                    )}
                    // sx={{
                    //   bgcolor: `${generateColor(
                    //     `${currentUser.first_name} ${currentUser.last_name}`
                    //   )}`,
                    // }}
                    sx={{
                      backgroundImage:
                        "linear-gradient(to bottom, #1273B8, #BE5060)",
                    }}
                  />
                )}
                <div
                  className={classes.HeaderUser_Name}
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: "15px", lineHeight: "1.2", color: "#fff" }}>
                    {`${currentUser.first_name} ${currentUser.last_name}`}
                  </Typography>
                  <Typography
                    className={classes.HeaderUser_designation}
                    sx={{ fontSize: "12px", opacity: 0.8, color: "#fff" }}
                  >
                    {currentUser.designation}
                  </Typography>
                </div>
                <svg
                  style={{ marginLeft: "10px" }}
                  width="10"
                  height="6"
                  viewBox="0 0 10 6"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1.94894 0.812821L5.00433 3.64107L8.05972 0.812821C8.36683 0.528539 8.86294 0.528539 9.17006 0.812821C9.47717 1.0971 9.47717 1.55633 9.17006 1.84061L5.55556 5.1864C5.24844 5.47068 4.75234 5.47068 4.44522 5.1864L0.830727 1.84061C0.523612 1.55633 0.523612 1.0971 0.830727 0.812821C1.13784 0.535828 1.64182 0.528539 1.94894 0.812821Z"
                    fill="white"
                  />
                </svg>
              </div>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.MenuItems}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.12))',
                    mt: 1.5,
                    borderRadius: '12px',
                    background: 'rgba(255, 255, 255, 0.8) !important',
                    backdropFilter: 'blur(12px) !important',
                    WebkitBackdropFilter: 'blur(12px) !important',
                    border: '1px solid rgba(255, 255, 255, 0.3)',
                    '& .MuiAvatar-root': {
                      width: 48,
                      height: 48,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 48,
                      width: 10,
                      height: 10,
                      bgcolor: 'rgba(255, 255, 255, 0.8)',
                      backdropFilter: 'blur(12px)',
                      WebkitBackdropFilter: 'blur(12px)',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                      borderLeft: '1px solid rgba(255, 255, 255, 0.3)',
                      borderTop: '1px solid rgba(255, 255, 255, 0.3)',
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                <div className={classes.ProfileDropdownHeader}>
                  {userInfo && userInfo.profile_pic && userInfo.profile_pic?.destination ? (
                    <Avatar
                      src={`${process.env.REACT_APP_IMAGE_URL}/${userInfo?.profile_pic?.destination}${userInfo?.profile_pic?.filename}`}
                    />
                  ) : (
                    <Avatar
                      {...stringAvatar(
                        `${currentUser.first_name?.trim()} ${
                          currentUser.last_name?.trim().charAt(0).toUpperCase() +
                          currentUser.last_name?.trim().slice(1)
                        }`
                      )}
                      sx={{
                        backgroundImage: "linear-gradient(to bottom, #1273B8, #BE5060)",
                        width: 48,
                        height: 48,
                      }}
                    />
                  )}
                  <div className={classes.ProfileDropdownSummary}>
                    <Typography className={classes.ProfileDropdownName}>
                      {`${currentUser.first_name} ${currentUser.last_name}`}
                    </Typography>
                    <Typography className={classes.ProfileDropdownDesignation}>
                      {currentUser.designation}
                    </Typography>
                  </div>
                </div>

                <MenuItem
                  onClick={handleMyProfileClick}
                  className={classes.HeaderMenuItem}
                >
                  <MyProfileIcon /> {ln.my_profile}
                </MenuItem>
                <div className={classes.MenuSeparator} />
                <MenuItem
                  onClick={handleChangeLanguage}
                  className={classes.HeaderMenuItem}
                >
                  <LanguageChangeIcon /> {ln.language}
                </MenuItem>
                <MenuItem
                  onClick={handleResetPassword}
                  className={classes.HeaderMenuItem}
                >
                  <ResetpasswordIcon /> {ln.reset_password}
                </MenuItem>
                <MenuItem
                  onClick={handleContactUS}
                  className={classes.HeaderMenuItem}
                >
                  <CallIcon /> {ln.contact_us}
                </MenuItem>
                <MenuItem
                  onClick={handleFeedback}
                  className={classes.HeaderMenuItem}
                >
                  <FeedBackIcon /> {ln.feedback}
                </MenuItem>
                <MenuItem
                  onClick={handleAboutUsClick}
                  className={classes.HeaderMenuItem}
                >
                  <AboutusIcon /> {ln.about_us}
                </MenuItem>
                <MenuItem
                  onClick={handlePoliciesClick}
                  className={classes.HeaderMenuItem}
                >
                  <PolicyIcon /> {ln.policies}
                </MenuItem>
                <div className={classes.MenuSeparator} />
                <MenuItem
                  onClick={() => setLogoutModal(true)}
                  className={classes.HeaderMenuItem}
                  sx={{ color: '#d32f2f !important' }}
                >
                  <LogoutIcon /> {ln.logout}
                </MenuItem>
              </Menu>
              {moddleToggle ? <LanguageModal modalClose={closeModal} /> : null}
            </div>
          ) : null}
        </div>
      ) : null}
      {logoutModal ? (
        <Modal
          open={logoutModal}
          onClose={() => closeModal()}
          aria-labelledby="server-modal-title"
          data-testid="register_modal"
          aria-describedby="server-modal-description"
          sx={{
            display: "flex",
            height: 480,
            marginTop: 10,
            justifyContent: "center",
          }}
          container={() => rootRef.current}
        >
          <Box
            sx={{
              position: "relative",
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: (theme) => theme.shadows[5],
            }}
            style={{
              width: "460px",
              height: "max-content",
              top: "20%",
            }}
            className={classes.loginModalWidth}
          >
            <div className={classes.deleteConformationFirstDiv}>
              <Typography
                className={classes.imagePageText}
                sx={{ mb: 1, width: "100%" }}
              >
                {ln.logout}
              </Typography>
              <Typography className={classes.successPageSubText}>
                {ln.are_you_sure_you_want_to_logout}
              </Typography>
              <div className={classes.addMemberModalbtnSection}>
                <Button variant="outlined" onClick={() => closeModal()}>
                  {ln.cancel}
                </Button>
                <Button variant="contained" onClick={() => handleLogout()}>
                  {ln.logout}
                </Button>
              </div>
            </div>
          </Box>
        </Modal>
      ) : null}
    </div>
  );
};

export default Header;
